export const CoastType = Object.freeze({
  Child: "Child",
  No: "No",
  Parent: "Parent",
});

export const GamePhaseType = Object.freeze({
  Builds: "Builds",
  Diplomacy: "Diplomacy",
  Retreats: "Retreats",
});

export const UnitType = Object.freeze({
  Army: "Army",
  Fleet: "Fleet",
});

export const TerritoryType = Object.freeze({
  Coast: "Coast",
  Land: "Land",
  Sea: "Sea",
});

export const OrderStatusType = Object.freeze({
  Hold: "Hold",
  Move: "Move",
  SupportHold: "Support hold",
  SupportMove: "Support move",
  Convoy: "Convoy",
  Retreat: "Retreat",
  Disband: "Disband",
  BuildArmy: "Build army",
  BuildFleet: "Build fleet",
  Wait: "Wait",
  Destroy: "Destroy",
});
